import { CpnSupportTicketType } from '@/types/cpn'

export const issueTypeLabels: Record<
  CpnSupportTicketType,
  { label: string; description: string }
> = {
  PAYMENT_SETTLEMENT_DELAY: {
    label: 'Payment Settlement Delay',
    description: 'Payment is taking longer than expected to settle',
  },
  PAYMENT_SENT_TO_WRONG_RECIPIENT: {
    label: 'Wrong Recipient',
    description: 'Payment was sent to the incorrect recipient',
  },
  PAYMENT_AMOUNT_INCORRECT: {
    label: 'Incorrect Amount',
    description: 'The payment amount received is incorrect',
  },
  REVERSE_FUNDS: {
    label: 'Reverse Funds',
    description: 'Request to reverse or cancel the payment',
  },
  OTHER: {
    label: 'Other Issue',
    description: 'Other payment-related issues',
  },
}
